import React, { Component } from 'react';

import getMyMap, {createCommunesLayer, createNamesLayer, createCommunesNamesLayerEasy} from './leaflet_map';

const L = window.L;

class LeafletMap extends React.Component {
  componentDidMount() {
    var communes = this.props.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    // --- init map
    var mymap = this.mymap = getMyMap(this.props.id, false, 0, false, false, false);

    // --- create layers
    var communes_layer = this.communes_layer = createCommunesLayer(mymap, communes, communes_names);
    //var commune_names_layer = this.commune_names_layer = createNamesLayer(mymap, communes_coords, communes_names);
    createCommunesNamesLayerEasy(mymap, communes)

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }

  render() {
    return(
      <div style={{height: "100%"}} id={this.props.id}></div>
    )
  }
}

export default LeafletMap;
